// extracted by mini-css-extract-plugin
export default {"userAgentWrapperRoot":"UserAgent_userAgentWrapperRoot__mozFJ","browserIcon":"UserAgent_browserIcon__vHikv"};